(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bm-soul-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bm-soul-hero')) {
  customElements.define('bm-soul-hero', class extends HTMLElement {
    connectedCallback() { requestAnimationFrame(() => this.initialize()); }
    initialize() {
      if (!this.isConnected || this.video) return;
      this.video = this.querySelector('[data-bm-film]');
      this.button = this.querySelector('[data-bm-film-toggle]');
      if (!this.video || !this.button) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.userPaused = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.video.defaultMuted = true;
      this.video.muted = true;
      this.video.playsInline = true;
      this.sync = () => {
        const paused = this.video.paused;
        const label = paused ? this.button.dataset.playLabel : this.button.dataset.pauseLabel;
        this.button.setAttribute('aria-label', label);
        this.button.querySelector('[data-bm-film-label]').textContent = label;
        this.button.querySelector('[data-bm-play]').toggleAttribute('hidden', !paused);
        this.button.querySelector('[data-bm-pause]').toggleAttribute('hidden', paused);
      };
      this.start = () => {
        if (this.userPaused || document.hidden) return;
        this.video.muted = true;
        const promise = this.video.play();
        if (promise) promise.catch(() => this.sync());
      };
      this.button.addEventListener('click', () => {
        if (this.video.paused) {
          this.userPaused = false;
          this.start();
        } else {
          this.userPaused = true;
          this.video.pause();
        }
      }, options);
      this.video.addEventListener('play', this.sync, options);
      this.video.addEventListener('pause', this.sync, options);
      this.video.addEventListener('canplay', this.start, options);
      window.addEventListener('pageshow', this.start, options);
      this.button.hidden = false;
      this.video.controls = false;
      if (this.userPaused) this.video.pause(); else this.start();
      this.sync();
    }
    disconnectedCallback() { this.abort?.abort(); this.video = null; }
  });
}

  } catch(e) { console.error(e); }
})();
})();
